import axios from "axios";

export default axios.create({
  baseURL:
    "https://www.hebcal.com/hebcal?v=1&cfg=json&maj=on&min=on&mod=on&year=now&month=x&mf=on&geo=geoname&geonameid=293396&m=0",
});
